import React from 'react';
import { Reveal } from '../Reveal';
import { useLaunchCountdown } from '../../hooks/useLaunchCountdown';
const SEATS_TAKEN = 68;
function Unit({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex w-[68px] flex-col items-center sm:w-[86px]" data-id="element-288" data-mp="2bki4cvmb8sbp">
      <span className="font-display text-5xl leading-none tabular-nums text-lime sm:text-6xl" data-id="element-289" data-mp="26kne8uad06rp">{value}</span>
      <span className="mt-2 text-[10px] font-extrabold uppercase tracking-[0.16em] text-snow-dim sm:text-xs" data-id="element-290" data-mp="33b63k24fbnmq">
        {label}
      </span>
    </div>;
}
export function Urgency() {
  const {
    hours,
    minutes,
    seconds,
    isExpired
  } = useLaunchCountdown();
  return <section className="w-full px-4 py-10 sm:px-5 sm:py-14" aria-labelledby="urgency-title" data-id="element-291" data-mp="2ufzumu9uwpfz">
      <Reveal className="mx-auto max-w-2xl" data-id="element-292" data-mp="2phf3rlghvi47">
        <div className="rounded-3xl bg-lime px-4 py-8 text-center shadow-[0_18px_44px_rgba(122,30,60,0.25)] sm:px-8 sm:py-10" data-id="element-293" data-mp="3myvr1x5bv1q5">
          <h2 id="urgency-title" className="mx-auto max-w-xl font-display text-2xl leading-tight text-ink sm:text-4xl" data-id="element-294" data-mp="3i6c78ig1racw">
            {isExpired ? 'La promoción de lanzamiento finalizó' : 'Precio de lanzamiento — cierra en:'}
          </h2>

          {!isExpired && <div className="mt-6 flex justify-center" data-id="element-295" data-mp="b8etdwlanckq">
              <div className="flex min-h-[104px] items-center justify-center gap-1 rounded-2xl border border-gold/40 bg-ink px-4 py-4 sm:min-h-[120px] sm:gap-2 sm:px-7" role="timer" aria-live="off" aria-label={`Quedan ${hours} horas, ${minutes} minutos y ${seconds} segundos`} data-id="element-296" data-mp="b5slfvuhqv1z">
                <Unit value={hours} label="HS" data-id="element-297" data-mp="6ad958c4t77o" />
                <span className="-mt-4 font-display text-3xl text-gold" aria-hidden="true" data-id="element-298" data-mp="3oeoldpzvxzli">
                  :
                </span>
                <Unit value={minutes} label="MIN" data-id="element-299" data-mp="3sh1pk9yzhpg6" />
                <span className="-mt-4 font-display text-3xl text-gold" aria-hidden="true" data-id="element-300" data-mp="1mn23cdxz1f16">
                  :
                </span>
                <Unit value={seconds} label="SEG" data-id="element-301" data-mp="1qox3vg82vodw" />
              </div>
            </div>}

          <p className="mx-auto mt-6 max-w-md text-sm font-extrabold text-gold-soft sm:text-base" data-id="element-302" data-mp="2zm3n7tr9m8zg">
            {isExpired ? 'El precio volvió a su valor habitual. Podés acceder a MegaPack Árabe PRO cuando quieras.' : 'Después sube $6.000 ARS. No vuelve.'}
          </p>

          {!isExpired && <div className="mt-7 rounded-2xl bg-black/15 px-4 py-5 sm:px-6" data-id="element-303" data-mp="2lm2ks9vcqthv">
              <p className="text-center text-xs font-extrabold text-ink sm:text-sm" data-id="element-304" data-mp="2lo5lbnu4s50u">
                <span className="mr-1.5 inline-block h-2 w-2 rounded-full bg-gold-soft align-middle" aria-hidden="true" data-id="element-305" data-mp="3ibabrxeqput6" />
                Cupos al precio de lanzamiento — <span className="text-gold-soft" data-id="element-306" data-mp="39iyhu1kf3p8g">quedan pocos</span>
              </p>

              <div className="mt-3.5 h-3 w-full overflow-hidden rounded-full bg-black/25" role="progressbar" aria-valuenow={SEATS_TAKEN} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos tomados al precio de lanzamiento" data-id="element-307" data-mp="34l6t1gf2kj8h">
                <div className="h-full rounded-full bg-gold-soft" style={{
              width: `${SEATS_TAKEN}%`
            }} data-id="element-308" data-mp="136fzmunpno0" />
              </div>

              <p className="mt-2 text-right text-[11px] font-extrabold text-gold-soft sm:text-xs" data-id="element-309" data-mp="de65k2os74ce">
                {SEATS_TAKEN}% tomados
              </p>
            </div>}
        </div>
      </Reveal>
    </section>;
}